import React from 'react';
import PropTypes from 'prop-types';
import Pagify from 'react-pagify';
import segmentize from 'segmentize';

const Paginator = ({
    pagination,
    page,
    pages,
    onSelect,
    setPerPage,
    setPage
}) => {
    page = page === 0 ? 1 : page + 1;
    const disabledPrevious = page === 1 ? ' pager-disabled' : '';
    const disabledNext = page === pages ? ' pager-disabled' : '';

    return (
        <div className="pagination">
            <Pagify.Context
                className="pagify-pagination"
                segments={segmentize({
                    page: page,
                    pages
                })}
                onSelect={onSelect}
            >
                <Pagify.Button
                    page={page - 1}
                    className={`previousButton ${disabledPrevious}`}
                >
                    Previous
                </Pagify.Button>

                <div className="center">
                    <div className="pageInfo">
                        Page
                        <div className="pageJump">
                            <input
                                onChange={setPage}
                                type="number"
                                value={page}
                                min="1"
                                max={pages}
                            />
                        </div>
                        <span className="totalPages"> of {pages}</span>
                    </div>
                    <div className="pageSizeOptions">
                        <select
                            onChange={setPerPage}
                            defaultValue={pagination.perPage}
                        >
                            <option value="5">5 rows</option>
                            <option value="10">10 rows</option>
                            <option value="20">20 rows</option>
                            <option value="25">25 rows</option>
                            <option value="50">50 rows</option>
                            <option value="100">100 rows</option>
                        </select>
                    </div>
                </div>

                <Pagify.Button
                    page={page + 1}
                    className={`nextButton ${disabledNext}`}
                >
                    Next
                </Pagify.Button>
            </Pagify.Context>
        </div>
    );
};

Paginator.propTypes = {
    pagination: PropTypes.object,
    pages: PropTypes.number,
    onSelect: PropTypes.func
};

export default Paginator;



// WEBPACK FOOTER //
// ./src/helpers/paginator.js